<template>
  <div>
    <Header :pageIndex="2"/>
    <CBanner imgUrl="/static/banner5.png" title1="企业服务" title-en="Service" title2="一站式服务能力，更优化的交付质量，更优化的交付效率"/>
    <CTitle title="/static/service-around.png" desc="Scope of services"/>
    <CSevice/>
    <div class="b2b-graph-section">
      <div class="b2b-graph-bg"></div>
      <CTitle title="/static/bussiness.png" desc="Business introduction"/>
      <div class="b2b-box">
        <div class="join-name">B2B<span style="font-family: YouSheBiaoTiHei;font-weight: 400">电商</span></div>
        <div class="join-desc">通过PC+移动端多样化的展现，便于经销商及企业内部人员随时随地根据需要处理业务</div>
        <div class="b2b-graph">
          <div class="b2b-graph-w3">
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">经销商的PC下单</div>
            </div>
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">经销商的PC数据查询，所有明细与总览</div>
            </div>
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">其他操作，如开票申请，返利转让申请等</div>
            </div>
          </div>
          <div class="b2b-graph-w2">
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">企业内部人员移动审批</div>
            </div>
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">简单数据的移动查询，如库存查询、每日订单</div>
            </div>
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">简单数据的移动查询，如库存查询、每日订单</div>
            </div>
          </div>
          <div class="b2b-graph-w1">
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">经销商的移动下单</div>
            </div>
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">经销商的移动查询平台</div>
            </div>
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">经销商的消息平台</div>
            </div>
          </div>
          <div class="b2b-graph-w4">B2B商城</div>
          <div class="b2b-graph-w5">
            <div class="b2b-graph-name">企业号</div>
            <div class="b2b-graph-desc">移动审批+</div>
            <div class="b2b-graph-desc">数据查询</div>
          </div>
          <div class="b2b-graph-w6">
            <div class="b2b-graph-name">微信商城</div>
            <div class="b2b-graph-desc">新增微信</div>
            <div class="b2b-graph-desc">服务号</div>
          </div>
          <div class="b2b-graph-w7">
            <div class="b2b-graph-name">PC商城</div>
            <div class="b2b-graph-desc">升级原有</div>
            <div class="b2b-graph-desc">电商平台</div>
          </div>
        </div>
      </div>
      <CProduct type="simple"/>
    </div>
  </div>
</template>

<script>
  import CSevice from "@/components/CSevice";
  import CTitle from "@/components/CTitle";
  import CProduct from "@/components/CProduct";
  import CBanner from "@/components/CBanner";
  import Header from "../Header";

  export default {
    name: "Service",
    components: {Header, CBanner, CTitle, CSevice, CProduct},
  }
</script>

<style scoped>
  .b2b-box {
    width: 1070px;
    margin: 50px auto 50px;
  }

  .join-name {
    font-size: 30px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #333333;
    line-height: 45px;
    letter-spacing: 1px;
  }

  .join-desc {
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #081457;
    line-height: 20px;
    margin-top: 16px;
    text-indent: 32px;
    width: 468px;
  }
  .b2b-graph-section{
    width: 100%;
    position: relative;
    height: 1064px;
  }
  .b2b-graph-bg{
    background-image: url("../../assets/bg6.png");
    width: 1920px;
    height: 1064px;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -960px;
    z-index: -1;
  }

  .b2b-graph {
    width: 313px;
    height: 312px;
    background-image: url("../../assets/qyfw_ywjs.png");
    margin: 60px auto 0;
    position: relative;
  }

  .b2b-graph-w1 {
    position: absolute;
    top: 155px;
    left: 295px;
    width: 259px;
    height: 111px;
    background: #FFFFFF;
    box-shadow: 0px 4px 15px 0px #E8E9F0;
    padding: 24px 0 0 25px;
  }

  .b2b-graph-w2 {
    position: absolute;
    top: -17px;
    left: 250px;
    width: 379px;
    height: 121px;
    background: #FFFFFF;
    box-shadow: 0px 4px 15px 0px #E8E9F0;
    padding: 24px 0 0 25px;
  }

  .b2b-graph-w3 {
    position: absolute;
    top: 120px;
    left: -395px;
    width: 379px;
    height: 114px;
    background: #FFFFFF;
    box-shadow: 0px 4px 15px 0px #E8E9F0;
    padding: 24px 0 0 25px;
  }
  .b2b-graph-w4{
    font-size: 16px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 24px;
    position: absolute;
    top: 132px;
    left: 141px;
    width: 35px;
  }
  .b2b-graph-w5{
    /*border: solid 2px blue;*/
    width: 90px;
    height: 100px;
    position: absolute;
    left: 112px;
    top: 42px;
    text-align: center;
  }
  .b2b-graph-w6{
    /*border: solid 2px blue;*/
    width: 90px;
    height: 100px;
    position: absolute;
    left: 185px;
    top: 170px;
    text-align: center;
  }
  .b2b-graph-w7{
    /*border: solid 2px blue;*/
    width: 90px;
    height: 100px;
    position: absolute;
    left: 38px;
    top: 170px;
    text-align: center;
  }
  .b2b-graph-name{
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #555567;
    line-height: 20px;
    margin-bottom: 2px;
  }
  .b2b-graph-desc{
    font-size: 12px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #555567;
    line-height: 17px;
  }

  .row-point {
    width: 6px;
    height: 6px;
    background: #F0F0F0;
    border: 1px solid #678DFF;
    border-radius: 50%;
    margin-right: 5px;
  }

  .row-text {
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #555567;
    line-height: 29px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contains/Service.vue